<template>
  <div v-show="loaded" class="global-lang-selector__overlay global-lang-selector__container ">
    <p class="sr-only visually-hidden global-language-picker-description">Select your language</p>

    <div class="global-lang-selector__selectbox u-pos-rel cursor-pointer OneLinkNoTx" role="listbox" tabindex="0"
      v-on:click="selectBoxClicked" v-on:keydown.enter="selectBoxClicked" v-on:focusout="selectBoxOut">

      <span class="global-lang-selector__currentlang">
        <img v-bind:src="current.FlagUrl" v-bind:alt="current.FlagAlt" />
        <span v-html="current.LanguageName"></span>
      </span>

      <span class="global-lang-selector__selectbox--chevron-btn"></span>

      <ul class="global-lang-selector__selectbox--options u-color-black u-bg-color-white u-hidden">
        <li role="option" v-for="lang in items">
          <a v-bind:href="lang.SiteUrl" v-on:click="goToLanguageClicked" v-bind:data-id="lang.Index"
            v-bind:title="'Go to ' + lang.FullName + ' site'">
            <img v-bind:src="lang.FlagUrl" v-bind:alt="lang.FlagAlt" />
            <span v-html="lang.FullName"></span>
          </a>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
// global-lang-selector
export default {
  name: 'GlobalLangSelector',
  props: {
    languages: {
      default: "global-language-data",
      type: String
    }
  },
  data() {
    return {
      items: [],
      current: {
        CountryName: "Development",
        LanguageName: "English",
        FlagUrl: "/content/images/flags/flag-us-svg.svg",
        SiteUrl: "/",
      },
      loaded: false
    };
  },
  mounted() {

    let data = document.getElementById(this.languages);
    if (data != null) {
      let json = data.innerText;

      let langs = JSON.parse(json);

      if (langs != null && langs.length > 0) {

        let site = window.location.origin.toLowerCase();

        for (var i = 0; i < langs.length; i++) {
          let lang = langs[i];
          lang.Index = i;
          lang.FullName = lang.CountryName + " - " + lang.LanguageName;
          this.items.push(lang);

          if (lang.SiteUrl.indexOf(site) === 0) {
            this.current = lang;
          }
        }
      }
      this.loaded = true;
    }



  },
  methods: {
    selectBoxClicked(e) {
      this.showOptions(e.currentTarget);
      if (typeof (window.dataLayer) !== "undefined" && typeof (window.dataLayer.push) !== "undefined") { window.dataLayer.push({ 'event': 'language_selector' }); }
    },
    selectBoxOut(e) {
      //console.log("selectBoxOut");
      var parent = $(e.relatedTarget).parent("global-lang-selector__selectbox");
      if (parent.length === 0) {
        this.hideOptions(e.currentTarget);
      }
      e.preventDefault();
      //console.log(e.relatedTarget);
      this.goToLanguage(e.relatedTarget);
    },
    hideOptions(target) {
      $(target)
        .children(".global-lang-selector__selectbox--options")
        .hide();
      $(target)
        .children(".global-lang-selector__selectbox--chevron-btn")
        .removeClass("show");
    },
    showOptions(target) {
      $(target)
        .children(".global-lang-selector__selectbox--options")
        .toggle();
      $(target)
        .children(".global-lang-selector__selectbox--chevron-btn")
        .toggleClass("show");
    },
    goToLanguageClicked(e) {

      e.preventDefault();

      if (e.target != null) {
        if (e.target.tagName == "A") {
          this.goToLanguage(e.target);
        }
        else {
          let parentLink = $(e.target).parent("a")[0];
          //console.log(parentLink);
          this.goToLanguage(parentLink);
        }
      }
    },
    goToLanguage(target) {
      //console.log("goToLanguage");
      let el = $(target);
      let elId = el.attr("data-id");
      if (elId != null) {
        let elIdNum = parseInt(elId);
        var lang = this.items[elIdNum];

        var gEventLang = lang.GEvent;

        if (typeof (window.dataLayer) !== "undefined" && typeof (window.dataLayer.push) !== "undefined") { window.dataLayer.push({ 'event': gEventLang }); }

        if (lang.CountryName == "USA" && this.current.CountryName != "USA") {
          // go right to USA site
          window.location.href = lang.SiteUrl;
        }
        else {
          if (lang.CountryName == this.current.CountryName && lang.LanguageName == this.current.LanguageName) {
            // we're already here, do nothing
          }
          else {
            if (this.current.CountryName != "Canada") {
              window.location.href = lang.SiteUrl;
            }
            else {
              var newUrl = lang.SiteUrl + window.location.pathname;
              window.location.href = newUrl;
            }
          }
        }
      }
    }
  }
};
</script>
